import React, { Fragment } from 'react';
import { array, func } from 'prop-types';
import { FMessage } from '../../../../hoc/IntlComponents';
import FlowsListItem from './FlowsListItem';
import CustomTable from '../../../../components/CustomTable/CustomTable';

const propTypes = {
  flows: array.isRequired,
  onFlowRemove: func.isRequired,
};

const defaultProps = {
  flows: [],
};

const FlowsList = ({ flows, onFlowRemove, sortOrder, sortBy, handleSort, tableSettings, onFlowCopy }) => {
  return (
    <Fragment>
      <CustomTable className="flows-list" bordered responsive stripped aria-label="Flows">
        <CustomTable.Wrapper>
          <CustomTable.Row>
            {/* <CustomTable.Cell
              sortBy={sortBy}
              sortOrder={sortOrder}
              sortName="encId"
              handleSort={handleSort}
              defaultSortOrder="desc"
              sorting
            >
              ID
            </CustomTable.Cell>
            <CustomTable.Cell
              sortBy={sortBy}
              sortOrder={sortOrder}
              sortName="its"
              handleSort={handleSort}
              defaultSortOrder="desc"
              sorting
            >
              <FMessage id="flows.table.added" />
            </CustomTable.Cell> */}
            {tableSettings.title && <CustomTable.Cell
              sortBy={sortBy}
              sortOrder={sortOrder}
              sortName="title"
              handleSort={handleSort}
              defaultSortOrder="desc"
              sorting
            >
              <FMessage id="flows.table.title" />
            </CustomTable.Cell>}
            {tableSettings.type && <CustomTable.Cell
              sortBy={sortBy}
              sortOrder={sortOrder}
              sortName="type"
              handleSort={handleSort}
              defaultSortOrder="desc"
              sorting
            >
              <FMessage id="flows.table.type" />
            </CustomTable.Cell>}
            {tableSettings.offer && <CustomTable.Cell
              sortBy={sortBy}
              sortOrder={sortOrder}
              sortName="offerTitle"
              handleSort={handleSort}
              defaultSortOrder="desc"
              sorting
            >
              <FMessage id="flows.table.offer" />
            </CustomTable.Cell>}
            {tableSettings.landing && <CustomTable.Cell
              sortBy={sortBy}
              sortOrder={sortOrder}
              sortName="landings"
              handleSort={handleSort}
              defaultSortOrder="desc"
              sorting
            >
              <FMessage id="flow.landings" />
            </CustomTable.Cell>}

            {tableSettings.transfer_page && <CustomTable.Cell
              sortBy={sortBy}
              sortOrder={sortOrder}
              sortName="transits"
              handleSort={handleSort}
              defaultSortOrder="desc"
              sorting
            >
              <FMessage id="flow.prelanders.theme_3" />
            </CustomTable.Cell>}

            <CustomTable.Cell />
            {tableSettings.statistics && <CustomTable.Cell className="table-controls" />}
            {tableSettings.copy && <CustomTable.Cell className="table-controls" />}
            {tableSettings.edit && <CustomTable.Cell className="table-controls" />}
            {tableSettings.remove && <CustomTable.Cell className="table-controls" />}
          </CustomTable.Row>
        </CustomTable.Wrapper>

        {flows.length > 0 && (
          <CustomTable.Wrapper type="body">
            {flows.map(flow => (
              <FlowsListItem
                tableSettings={tableSettings}
                onFlowCopy={onFlowCopy}
                key={flow.id}
                {...flow}
                onFlowRemove={onFlowRemove}
                count={flows.length}
              />
            ))}
          </CustomTable.Wrapper>
        )}
      </CustomTable>
    </Fragment>
  );
};

FlowsList.propTypes = propTypes;
FlowsList.defaultProps = defaultProps;

export default FlowsList;
